import { useContext } from 'react';
import { ScreenSizeContext, type ScreenSizeContextValue } from '~/common/components/context/ScreenSizeContext.tsx';

export function useScreenSize(): ScreenSizeContextValue {
  const context = useContext(ScreenSizeContext);
  if (!context) {
    throw new Error('useScreenSize must be used within ScreenSizeProvider');
  }
  return context;
}
